module.exports = __webpack_public_path__ + "img/himg2.02b12b56.jpg";